import { Link } from 'react-router-dom'

const ToolBarLink = ({ href, icon, label, as = 'link', onClick = () => {} }) => {
  return as === 'link' ? (
    <Link
      className="w-10 h-10 rounded-md hover:bg-[#F4C8A8] inline-flex items-center justify-center transition-colors duration-200 ease"
      to={href}
      aria-label={label}
    >
      <img className="inline-block" src={icon} alt={label} />
    </Link>
  ) : (
    <button
      className="w-10 h-10 rounded-md hover:bg-[#F4C8A8] inline-flex items-center justify-center transition-colors duration-200 ease"
      onClick={onClick}
      aria-label={label}
      type="button"
    >
      <img className="inline-block" src={icon} alt={label} />
    </button>
  )
}

export default ToolBarLink
